var exports = {
  "Kk": "InviteEmbed.module__icon___bmh1N1",
  "EU": "InviteEmbed.module__iconFallback___bmh1N1",
  "C1": "InviteEmbed.module__titleRowWithIcon___bmh1N1",
  "gn": "InviteEmbed.module__titleContainer___bmh1N1",
  "Qw": "InviteEmbed.module__titleText___bmh1N1",
  "fH": "InviteEmbed.module__headerInvite___bmh1N1",
  "dT": "InviteEmbed.module__inviteWrapper___bmh1N1",
  "M1": "InviteEmbed.module__stats___bmh1N1",
  "dJ": "InviteEmbed.module__stat___bmh1N1",
  "gW": "InviteEmbed.module__statDot___bmh1N1",
  "rR": "InviteEmbed.module__statDotOnline___bmh1N1",
  "rb": "InviteEmbed.module__statDotMembers___bmh1N1",
  "KA": "InviteEmbed.module__statText___bmh1N1",
};

module.exports = exports;
